import React from 'react';
import appApiTest from './test';

const ApiContext = React.createContext(appApiTest); // test api by default

export default ApiContext;
